export const LOAD_COMPLETE = "teams::load::complete";
export const FIELD_UPDATE = "teams::field::update";
